import React, { useEffect, useState } from "react";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { producaov2 as api } from "../../../services/apis";
import { Header, Loader, Modal, Table, Button, Input } from "semantic-ui-react";
import { Container, Content, Line, ButtonOpen, Center, Nav, TableContainer, InputContainer } from './styles'
import swal from 'sweetalert';

const NewAllInPage = () => {
  const [loading, setLoading] = useState(false)
  const [allInUsers, setAllInUsers] = useState([])
  const [userSelected, setUserSelected] = useState(null)
  const [dateStart, setDateStart] = useState('')
  const [dateEnd, setDateEnd] = useState('')
  const [loadingReport, setLoadingReport] = useState(false)
  const [report, setReport] = useState(null)
  const [searchEmail, setSearchEmail] = useState('');

  useEffect(() => {
    (async () => {
      setLoading(true)
      await api.get('/admin/find-all-new-allin')
        .then((res) => {
          setAllInUsers(res.data)
        })
        .catch((err) => {
          console.error(err)
          setAllInUsers([])
        })
        .finally(() => {
          setLoading(false)
        })
    })()
  }, [])

  function generateReport() {
    setLoadingReport(true)

    if (!dateStart || !dateEnd) {
      swal('Atenção', 'Informe a data inicial e final', 'warning')
      setLoadingReport(false)
      return
    }

    api.post(`/admin/reports/analytic-new-all-in-student`, {
      dateStart,
      dateEnd
    })
      .then((res) => {
        console.log(res.data)
        setReport(res.data.url)
      })
      .catch((err) => {
        console.error(err.response)
      })
      .finally(() => {
        setLoadingReport(false)
      })
  }

  const filteredAllInUsers = allInUsers.filter(user => user?.email?.includes(searchEmail));

  return (
    <>
      <AdminMenu />
      <Container>
        <Content>
          <Nav>
            <h1>Novos All In</h1>
            <nav>
              <div className="filter_container">
                <div className="ui fluid" style={{ width: "50%" }}>
                  <strong>De:</strong>
                  <div className="ui input fluid">
                    <input
                      type="date"
                      onChange={(e) => setDateStart(e.target.value)}
                      value={dateStart}
                    />
                  </div>
                </div>
                <div className="ui fluid"
                  style={{ marginLeft: "16px", width: "50%" }}
                >
                  <strong>Até:</strong>
                  <div className="ui input fluid">
                    <input
                      type="date"
                      onChange={(e) => setDateEnd(e.target.value)}
                      value={dateEnd}
                    />
                  </div>
                </div>
              </div>
              <div>
                <Button
                  color="orange"
                  style={{ minWidth: "139px", minHeight: '36px' }}
                  onClick={generateReport}
                  loading={loadingReport}
                >
                  Gerar Relatório
                </Button>
              </div>
              {report && (
                <Button
                  style={{ marginTop: "12px" }}
                  onClick={() => window.open(report, "_blank")}
                  color="green"
                >
                  Baixar Relatório
                </Button>
              )}
            </nav>

          </Nav>
          <InputContainer>
            <Input
              fluid
              placeholder="Pesquise pelo email"
              value={searchEmail}
              onChange={e => setSearchEmail(e.target.value)}
            />
          </InputContainer>
          <TableContainer>
            <Table stackable>
              <Table.Header>
                <Table.HeaderCell>
                  <Center>Id pedido</Center>
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <Center>Aluno</Center>
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <Center>Email</Center>
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <Center>Plano</Center>
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <Center>Convites enviados</Center>
                </Table.HeaderCell>
                <Table.HeaderCell>
                </Table.HeaderCell>
              </Table.Header>

              <Table.Body>
                {loading ? <Loader active={loading} /> :
                  filteredAllInUsers?.length > 0 && filteredAllInUsers.map((user) => (
                    <Table.Row>
                      <Table.Cell>
                        <Center>{user.id_owner}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{user.nome}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{user.email}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>+{user.total_indicacoes} contas</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{user.indicacoes}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>
                          <ButtonOpen onClick={() => setUserSelected(user)}>
                            Convites
                          </ButtonOpen>
                        </Center>
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
          </TableContainer>

          {userSelected && (
            <Modal
              closeIcon
              open={!!userSelected}
              onClose={() => setUserSelected(null)}
              style={{
                width: '50%'
              }}
            >
              <Header content={`Aluno: ${userSelected.nome}`} />
              <Modal.Content >
                <h3> Plano: + {userSelected.total_indicacoes} contas</h3>
                {userSelected.accounts.length > 0 ? (
                  <div>
                    <Line header>
                      <div>Id pessoa</div>
                      <div>email</div>
                      <div>Telefone</div>
                      <div>Ativo</div>
                    </Line>
                    {userSelected.accounts.map((account, index) => {
                      return (
                        <Line key={index} >
                          <div>{account.id}</div>
                          <div>{account.email}</div>
                          <div>{account.phone}</div>
                          <div>{account.used ? 'Convite aceito' : 'Pendente'}</div>
                        </Line>
                      )
                    })}
                  </div>

                ) : <p>Aluno ainda não enviou nenhum convite</p>}
              </Modal.Content>
            </Modal>
          )}
        </Content>
      </Container>
    </>
  );
};

export default NewAllInPage;
